import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import PhoneNumber from "../common/inputv2/PhoneNumber";
import { formatPhoneNumber } from "../../helpers/formatting";
import { logUI } from '../../api/andyliticsApi';
import ToggleSwitch from "../common/input/ToggleSwitch";
import { Modal, ModalBody } from 'reactstrap';
import * as Tools from "../../helpers/Tools";

class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inInputMode: false,
            isValid: false,
            showStatus: false,
            showToolTip: false,
            mobileNumber: '',
            alreadySet: false,
            openModal: false

        };

        this.createOrUpdatePhoneNumber = this.createOrUpdatePhoneNumber.bind(this);
        this.toggleInputMode = this.toggleInputMode.bind(this);
        this.getFormattedPhone = this.getFormattedPhone.bind(this);

        const urlParams = new URLSearchParams(window.location.search.toLowerCase());
        this.lanId = urlParams.get('lanid');
        this.props.getSettings(this.lanId);
    }

    createOrUpdatePhoneNumber() {
        if (this.state.mobileNumber === '') {
            this.setState({ openModal: true });
        }
        if (this.state.isValid) {
            logUI("UI.Notifications.Btn.Save.Clicked", new Date(), Tools.getURLPath());
            this.props.updateMobileNumber(this.lanId, { smsNumber: this.state.mobileNumber }, () => {
                this.setState({ inInputMode: false, showStatus: true });
            });
        }
    }

    deletePhoneNumber = () => {
        logUI("UI.Notifications.DeletePhoneNumber.Modal.OKAY", new Date(), Tools.getURLPath());
        this.props.updateMobileNumber(this.lanId, { smsNumber: '', sendSms: false }, () => {
            this.setState({ openModal: !this.state.openModal, mobileNumber: null, inInputMode: false });
        });
    }

    getFormattedPhone(phone) {
        if (phone && phone.PhoneNumber) {
            return `${phone.AreaCode}.${phone.PhoneNumber.substr(0, 3)}.${phone.PhoneNumber.substr(3)}`
        }
    }

    handleInputChange(event, isValid) {
        if (event) {
            const value = event.target.value;
            this.setState({ mobileNumber: value, isValid });
        }
    }

    toggleInputMode(cancel) {
        const { userSettings } = this.props;
        logUI(`UI.Notifications.PhoneNumber.EditMode.${cancel ? 'Cancel' : 'Open'}`, new Date(), Tools.getURLPath());
        this.setState(prevState => ({
            inInputMode: !prevState.inInputMode,
            mobileNumber: userSettings && formatPhoneNumber(userSettings.smsNumber),
            showStatus: false
        }));
    }

    onSmsNotificationChange(UseSms) {
        const { userSettings, savePreference } = this.props;
        const inInputMode = UseSms && userSettings && !userSettings.smsNumber;
        logUI(`UI.Notifications.SmsNotification.${UseSms ? 'Toggle' : 'Untoggle'}`, new Date(), Tools.getURLPath());
        savePreference(this.lanId, { sendSms: UseSms }, () => {
            this.setState({ UseSms, inInputMode, showStatus: false });
        });
    }

    toggleModal = () => {
        logUI("UI.Notifications.DeletePhoneNumber.Modal.Cancel", new Date(), Tools.getURLPath());
        this.setState({
            openModal: !this.state.openModal,
            showStatus: false
        })
    }

    render() {
        let { userSettings } = this.props;
        const { inInputMode, mobileNumber, isValid, showStatus, openModal } = this.state;
        const formattedMobileNumber = userSettings && formatPhoneNumber(userSettings.smsNumber);
        const useSms = inInputMode || (userSettings && userSettings.sendSms && formattedMobileNumber);
        const hasError = userSettings && userSettings.error !== null;

        return (

            <div className="container-fluid body-content notifications-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="page-heading">Notifications</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 list-item-col not-linked">
                                <div className="row">
                                    <div className="col-12 col-sm-4 col-md-9">
                                        <div className="list-item-col__label">TEXT</div>
                                        <p className="label__description">Be notified when a patient enters the room.</p>
                                    </div>
                                    <div className="col-12 col-sm-8 col-md-3 text-left text-sm-right">
                                        <div className="list-item-col__info">
                                            <ToggleSwitch name="textNotifications"
                                                checked={useSms}
                                                onChange={checked => this.onSmsNotificationChange(checked)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {formattedMobileNumber &&
                                    <div className="row align-items-end notifications-mobile-number">
                                        <div className="col-8 col-sm-6 col-lg-3 order-1">
                                            <div className="list-item-col__label">MOBILE NUMBER</div>
                                        </div>
                                        <div className="col-12 col-lg-6 order-3 order-lg-2">
                                            <div className="list-item-col__info">{formattedMobileNumber ? formattedMobileNumber : ''}</div>
                                        </div>
                                        {!inInputMode &&
                                            <div className="col-4 col-sm-6 col-lg-3 text-right order-2 order-lg-3">
                                                <div className="list-item-col__action">
                                                    <button type="button" className="btn text-btn" onClick={() => this.toggleInputMode(false)}>Edit</button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                {inInputMode &&
                                    <div className="row edit-mode">
                                        <div className="col-12 form-group">
                                            <PhoneNumber name="PhoneNumber" placeholder="Mobile Phone Number"
                                                onChange={(e, isValid) => this.handleInputChange(e, isValid)}
                                                value={mobileNumber} ref="PhoneNumber" required autoFocus
                                                showClearBtn />
                                        </div>
                                        <div className="col-12 col-lg-12 text-sm-right">
                                            <div className="list-item-col__action">
                                                <button type="button" className="list-item-col__action--btn cancel btn" onClick={() => this.toggleInputMode(true)}>Cancel</button>
                                                <button type="button" className="list-item-col__action--btn btn" onClick={this.createOrUpdatePhoneNumber}>Save</button>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {showStatus &&
                                    <div className="row">
                                        <div className="col-12">
                                            {hasError ?
                                                <div className="error-msg"><span className="icon-input-error" />We were unable to save your mobile number.</div> :
                                                <div className="success-msg"><span className="icon-list-check" />We’ve successfully saved your mobile number!</div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Modal className="modal-dialog notifications-delete-modal verify-modal modal-dialog-centered" isOpen={openModal} toggle={this.toggleModal} centered backdrop="static">
                    <ModalBody>
                        <div className="row">
                            <div className="col-12">
                                <p>By deleting your mobile number, you will no longer receive notifications.</p>
                                <div className="row justify-content-between link-container">
                                    <div className="col-4 text-btn link-left" onClick={this.toggleModal}>CANCEL</div>
                                    <div className="col-4 text-btn link-right" onClick={this.deletePhoneNumber}>OKAY</div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        userSettings: state.sso.userSettings,
        userName: state.domain.un
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSettings: (lanId) => dispatch({ type: types.USER_SETTINGS, event: 'GetSettings', lanId, payload: null, waiting: true }),
        updateMobileNumber: (lanId, payload, callback) => dispatch({ type: types.USER_SETTINGS, event: 'UpdateMobileNumber', lanId, payload, waiting: true, callback }),
        savePreference: (lanId, payload, callback) => dispatch({ type: types.USER_SETTINGS, event: 'SavePreference', lanId, payload, waiting: true, callback }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
